import http from 'helpers/requests';
import {
  invitationClaimErrorSchema,
  invitationClaimSchema,
  invitationInspectSchema,
} from './invitationContracts';

export class SupplierInvitationApiError extends Error {
  constructor(payload, httpStatus) {
    super(payload.message);
    this.name = 'SupplierInvitationApiError';
    this.payload = payload;
    this.httpStatus = httpStatus;
  }
}

export async function inspectSupplierInvitation(token) {
  const response = await http.publicPost('/invite/verify', { token });
  return invitationInspectSchema.parse(response?.data);
}

export async function claimSupplierInvitation(token, organizationName) {
  try {
    const response = await http.post('/invite/claim', {
      token,
      ...(organizationName ? { organizationName } : {}),
    });
    return invitationClaimSchema.parse(response?.data);
  } catch (error) {
    const parsed = invitationClaimErrorSchema.safeParse(error?.response?.data);
    if (parsed.success) {
      throw new SupplierInvitationApiError(parsed.data, error.response?.status);
    }
    throw error;
  }
}
